import { createContext } from 'react';

import type { Location, NavigateFunction, Params, To } from 'react-router-dom';

export interface RouterContextType {
  navigate: NavigateFunction;
  location: Location;
  params: Params;
}

export interface NavigateOptions {
  replace?: boolean;
  state?: any;
  preventScrollReset?: boolean;
  relative?: 'route' | 'path';
}

export const RouterContext = createContext<RouterContextType | null>(null);

declare global {
  interface Window {
    __pendingNavigations?: Array<[To, NavigateOptions | undefined]>;
  }
}
